/* MTD Slide cart — open/close, quantity, add-on, countdown.

   Cart mutations use the Section Rendering API: every /cart/*.js call asks
   Shopify to return this section's fresh HTML in the same response, so the
   markup is always rendered by Liquid and never assembled here. That keeps
   money, discounts and free-gift logic in one place. */
(function () {
  'use strict';

  var SECTION = 'mtd-cart-drawer';
  var root = function () { return document.querySelector('[data-mtd-cart]'); };

  /* ---------- Open / close ---------- */
  var lastFocus = null;

  function open() {
    var el = root();
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var close = el.querySelector('.mtd-cart__close');
    if (close) close.focus();
    startCountdown();
  }

  function close() {
    var el = root();
    if (!el) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Countdown ----------
     The deadline lives in sessionStorage so it survives navigation instead of
     restarting on every page — a timer that resets is not a reservation. */
  var ticker = null;

  function startCountdown() {
    var el = root();
    if (!el) return;
    var node = el.querySelector('[data-mtd-countdown]');
    var clock = el.querySelector('[data-mtd-clock]');
    if (!node || !clock) return;

    var minutes = parseFloat(el.dataset.countdownMinutes) || 10;
    var key = 'mtd-cart-deadline';
    var deadline = parseInt(sessionStorage.getItem(key) || '0', 10);
    if (!deadline || deadline < Date.now()) {
      deadline = Date.now() + minutes * 60000;
      sessionStorage.setItem(key, String(deadline));
    }

    node.hidden = false;
    clearInterval(ticker);

    function tick() {
      var left = Math.max(0, deadline - Date.now());
      var m = Math.floor(left / 60000);
      var sec = Math.floor((left % 60000) / 1000);
      clock.textContent = m + ':' + (sec < 10 ? '0' : '') + sec;
      if (left <= 0) {
        clearInterval(ticker);
        node.hidden = true;
        sessionStorage.removeItem(key);
      }
    }
    tick();
    ticker = setInterval(tick, 1000);
  }

  /* ---------- Re-render from a cart response ---------- */
  /* The two endpoints return different shapes:
       /cart/*.js with a sections param -> { ...cart, sections: { id: html } }
       ?sections=id                     -> { id: html }
     Accept both, and never recurse into refetch on failure. */
  function extract(data) {
    if (!data) return null;
    if (data.sections && data.sections[SECTION]) return data.sections[SECTION];
    if (typeof data[SECTION] === 'string') return data[SECTION];
    return null;
  }

  function paint(data) {
    var html = extract(data);
    if (!html) return false;

    var fresh = new DOMParser().parseFromString(html, 'text/html')
      .querySelector('[data-mtd-cart]');
    if (!fresh) return false;

    var el = root();
    if (!el) return false;

    var wasOpen = el.classList.contains('is-open');
    el.replaceWith(fresh);
    // Re-open on the next frame so the panel animates in rather than
    // appearing already slid out.
    if (wasOpen) requestAnimationFrame(function () { fresh.classList.add('is-open'); });

    syncCount(fresh.dataset.itemCount);
    startCountdown();
    return true;
  }

  function refetch() {
    return fetch(window.Shopify.routes.root + '?sections=' + SECTION)
      .then(function (r) { return r.json(); })
      .then(function (data) { return paint(data); })
      .catch(function () { return false; });
  }

  // Keep the header bubble in step with the drawer.
  function syncCount(count) {
    var n = parseInt(count || '0', 10);
    document.querySelectorAll('[data-mtd-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
    var bubble = document.querySelector('.mtd-header__count');
    var cartLink = document.querySelector('.mtd-header__cart');
    if (!cartLink) return;
    if (n > 0) {
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'mtd-header__count';
        bubble.setAttribute('aria-hidden', 'true');
        cartLink.appendChild(bubble);
      }
      bubble.textContent = n;
    } else if (bubble) {
      bubble.remove();
    }
    cartLink.setAttribute('aria-label', 'Cart, ' + n + ' items');
  }

  function busy(on) {
    var el = root();
    if (el) el.classList.toggle('is-busy', on);
  }

  function post(url, body) {
    busy(true);
    body.sections = SECTION;
    return fetch(window.Shopify.routes.root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // If the response carried no markup, pull it separately.
        if (!paint(data)) return refetch();
      })
      .catch(function () { return refetch(); })
      .finally(function () { busy(false); });
  }

  /* ---------- Delegated events ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mtd-cart-open], .mtd-header__cart');
    if (opener) {
      // With the drawer switched off — or replaced by a cart app — leave the
      // link alone so it still reaches the cart page.
      if (!root()) return;
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-mtd-cart-close]')) { close(); return; }

    var qty = e.target.closest('[data-mtd-qty]');
    if (qty) {
      post('cart/change.js', { id: qty.dataset.mtdQty, quantity: Number(qty.dataset.to) });
    }
  });

  document.addEventListener('change', function (e) {
    var bump = e.target.closest('[data-mtd-bump]');
    if (!bump) return;
    if (bump.checked) {
      post('cart/add.js', { items: [{ id: Number(bump.dataset.variant), quantity: 1 }] });
    } else if (bump.dataset.key) {
      post('cart/change.js', { id: bump.dataset.key, quantity: 0 });
    }
  });

  document.addEventListener('keydown', function (e) {
    var el = root();
    if (e.key === 'Escape' && el && el.classList.contains('is-open')) close();
  });

  /* ---------- Boot ---------- */
  function boot() {
    var el = root();
    if (!el) return;

    // Optional pre-ticked add-on. Added once per session only, so removing it
    // does not immediately put it back.
    var auto = el.dataset.bumpAutoadd;
    if (auto && !sessionStorage.getItem('mtd-bump-added')) {
      sessionStorage.setItem('mtd-bump-added', '1');
      post('cart/add.js', { items: [{ id: Number(auto), quantity: 1 }] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }

  document.addEventListener('shopify:section:load', boot);

  // Let other scripts open the drawer after adding to cart.
  // refresh() resolves once the markup is in the DOM, so callers can open the
  // drawer on fresh content rather than the state it had at page load.
  window.MTDCart = {
    open: open,
    close: close,
    refresh: refetch,
    render: paint,
    openWithRefresh: function () {
      return refetch().then(function () { open(); });
    }
  };
})();
